import { getData, postData } from "./apiInstance";
import { AxiosResponse } from "axios";

import {
  AppVersionType,
  GetAppVersionType,
} from "@/commonTypes/appVersionType";

import { getCSRFToken } from "@/utils/commonFunctions";

export async function postAppVersionApi(
  data: AppVersionType
): Promise<AxiosResponse> {
  const { token, ...finalData } = data;
  return await postData("/mobile-app/version/add", finalData, {
    headers: {
      "Content-Type": "application/json",
      "x-csrf-token": getCSRFToken(),
      "user-token": token,
    },
  });
}

export async function getAppVersionApi(
  data: GetAppVersionType
): Promise<AxiosResponse> {
  return await getData(
    `mobile-app/version/details?app_name=${data.app_name}&type=${data.type}`,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
}
